<template>
  <section class="pricing-section section-padding bg-green-light">
    <div class="container">
      <!-- Section Header -->
      <div class="section-header text-center mb-5">
        <h2 class="section-title text-gradient-primary">
          Registration Packages
        </h2>
        <p class="section-subtitle">
          Choose the perfect package for your digital workplace transformation journey
        </p>
      </div>

      <!-- Pricing Cards Grid -->
      <div class="pricing-grid">
        <div class="row g-4 justify-content-center">
          <div
            v-for="plan in pricingPlans"
            :key="plan.id"
            class="col-lg-4 col-md-6"
          >
            <PricingCard
              :title="plan.title"
              :subtitle="plan.subtitle"
              :icon="plan.icon"
              :price="plan.price"
              :original-price="plan.originalPrice"
              :period="plan.period"
              :price-description="plan.priceDescription"

              :variant="plan.variant"
              :icon-color="plan.iconColor"
              :featured="plan.featured"
              :popular="plan.popular"
              :discount="plan.discount"
              :button-text="plan.buttonText"
              :button-icon="plan.buttonIcon"
              :secondary-actions="plan.secondaryActions"
              :fine-print="plan.finePrint"
              @select-plan="handlePlanSelection"
              @secondary-action="handleSecondaryAction"
            />
          </div>
        </div>
      </div>

      <!-- Additional Information -->
      <div class="pricing-info-section mt-5">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="info-container card-glass p-4">
              <div class="row g-4">
                <div class="col-md-4 text-center">
                  <div class="info-item">
                    <SvgIcon name="shield" size="2xl" color="success" class="mb-3" />
                    <h5 class="info-title">Secure Payment</h5>
                    <p class="info-text">SSL encrypted transactions and multiple payment options available</p>
                  </div>
                </div>
                <div class="col-md-4 text-center">
                  <div class="info-item">
                    <SvgIcon name="calendar" size="2xl" color="primary" class="mb-3" />
                    <h5 class="info-title">Flexible Booking</h5>
                    <p class="info-text">Early bird discounts and group registration packages available</p>
                  </div>
                </div>
                <div class="col-md-4 text-center">
                  <div class="info-item">
                    <SvgIcon name="phone" size="2xl" color="warning" class="mb-3" />
                    <h5 class="info-title">24/7 Support</h5>
                    <p class="info-text">Dedicated registration support team ready to assist you</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Early Bird Banner -->
      <!-- <div v-if="showEarlyBirdBanner" class="early-bird-banner mt-5">
        <div class="banner-container">
          <div class="banner-content">
            <div class="banner-icon">
              <SvgIcon name="clock" size="2xl" color="warning" />
            </div>
            <div class="banner-text">
              <h4 class="banner-title">Early Bird Special</h4>
              <p class="banner-description">
                Save {{ earlyBirdDiscount }}% when you register before {{ earlyBirdDeadline }}!
              </p>
            </div>
            <div class="banner-action">
              <button class="btn btn-gradient-primary" @click="handleEarlyBirdClick">
                Register Now & Save
              </button>
            </div>
          </div>
        </div>
      </div> -->


    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { animate, stagger } from 'animejs'
import PricingCard from './PricingCard.vue'
import SvgIcon from './SvgIcon.vue'

export default {
  name: 'PricingSection',
  components: {
    PricingCard,
    SvgIcon
  },
  setup() {
    const showEarlyBirdBanner = ref(true)
    const earlyBirdDiscount = ref(20)
    const earlyBirdDeadline = ref('January 15, 2026')

    const pricingPlans = [
      {
        id: 'tanzania',
        title: 'Tanzania Delegate',
        subtitle: 'Perfect for local professionals and organizations',
        icon: 'location',
        price: 400,
        originalPrice: null,
        period: '',
        priceDescription: 'Complete summit experience for Tanzanian participants',
        features: [
          'Full 4-day summit access',
          'Welcome cocktail reception',
          'All networking sessions',
          'Digital summit materials',
          'Certificate of participation',
          'Post-summit resource access',
          'Exhibition hall access',
          'Morning coffee & refreshments'
        ],
        benefits: [
          {
            name: 'Local Network',
            value: '100+ Local Contacts',
            icon: 'users',
            color: 'success'
          },
          {
            name: 'Savings',
            value: 'Best Value',
            icon: 'dollar-sign',
            color: 'warning'
          }
        ],
        variant: 'success',
        iconColor: 'success',
        featured: false,
        popular: false,
        discount: null,
        buttonText: 'Register Now',
        buttonIcon: 'arrow-right',
        //   {
        //     text: 'Download Details',
        //     icon: 'download',
        //     href: '/tanzania-package.pdf'
        //   }
        // ],
        finePrint: 'Valid ID required for verification. Local payment options available.'
      },
      {
        id: 'east-africa',
        title: 'East Africa Delegate',
        subtitle: 'Enhanced experience for regional professionals',
        icon: 'users',
        price: 500,
        // originalPrice: 600,
        period: '',
        priceDescription: 'Premium experience for East African delegates',
        features: [
          'Everything in Tanzania package',
          'Priority seating in all sessions',
          'Complimentary lunch all 4 days',
          'VIP networking sessions',
          'Professional headshot session',
          'Welcome gift package',
          'Mobile app with AI assistant',
          'Express check-in service'
        ],
        benefits: [
          {
            name: 'Priority Access',
            value: 'VIP Treatment',
            icon: 'star',
            color: 'primary'
          },
          {
            name: 'Meals',
            value: 'All Included',
            icon: 'heart',
            color: 'warning'
          }
        ],
        variant: 'primary',
        iconColor: 'primary',
        featured: true,
        popular: true,
        // discount: 17,
        buttonText: 'Most Popular Choice',
        buttonIcon: 'star',
        finePrint: 'Includes transportation from select regional airports.'
      },
      {
        id: 'international',
        title: 'International Delegate',
        subtitle: 'Luxury experience for global participants',
        icon: 'globe',
        price: 700,
        // originalPrice: 850,
        period: '',
        priceDescription: 'Premium experience with concierge services',
        features: [
          'Everything in East Africa package',
          'Dedicated concierge service',
          'Airport transfer service',
          'All meals + daily dinner',
          'Exclusive executive lounge access',
          'One-on-one mentor sessions',
          'Premium accommodation assistance',
          'Post-summit implementation support'
        ],
        benefits: [
          {
            name: 'Concierge',
            value: '24/7 Service',
            icon: 'clock',
            color: 'warning'
          },
          {
            name: 'Mentorship',
            value: 'Expert Access',
            icon: 'user',
            color: 'primary'
          }
        ],
        variant: 'warning',
        iconColor: 'warning',
        featured: false,
        popular: false,
        // discount: 18,
        buttonText: 'Premium Experience',
        buttonIcon: 'star',
        finePrint: 'Includes visa assistance and travel insurance recommendations.'
      }
    ]

    const handlePlanSelection = (planData) => {
      console.log('Selected plan:', planData)
      // Navigate to registration with selected plan
      window.location.href = `/registration?plan=${planData.title.toLowerCase().replace(/\s+/g, '-')}`
    }

    const handleSecondaryAction = (action) => {
      console.log('Secondary action:', action)
      if (action.href) {
        if (action.href.startsWith('#')) {
          // Scroll to element
          const element = document.querySelector(action.href)
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
          }
        } else {
          // Open link
          window.open(action.href, '_blank')
        }
      }
    }

    const handleEarlyBirdClick = () => {
      window.location.href = '/registration?early-bird=true'
    }

    const handleGroupInquiry = () => {
      window.location.href = 'mailto:groups@idws.org?subject=Group Registration Inquiry'
    }

    const handleDownloadBrochure = () => {
      // Trigger download
      const link = document.createElement('a')
      link.href = '/assets/idws-2026-brochure.pdf'
      link.download = 'IDWS-2026-Summit-Brochure.pdf'
      link.click()
    }

    onMounted(() => {
      // Animate pricing cards with stagger
      animate('.pricing-card', {
        opacity: [0, 1],
        translateY: [50, 0],
        scale: [0.95, 1],
        duration: 700,
        delay: stagger(150),
        easing: 'easeOutExpo'
      })

      // Animate info items
      animate('.info-item', {
        opacity: [0, 1],
        translateY: [30, 0],
        duration: 600,
        delay: stagger(100, {start: 500}),
        easing: 'easeOutExpo'
      })

      // Animate banners
      setTimeout(() => {
        animate('.early-bird-banner, .group-registration-cta', {
          opacity: [0, 1],
          scale: [0.95, 1],
          duration: 600,
          easing: 'easeOutBack'
        })
      }, 1000)
    })

    return {
      pricingPlans,
      showEarlyBirdBanner,
      earlyBirdDiscount,
      earlyBirdDeadline,
      handlePlanSelection,
      handleSecondaryAction,
      handleEarlyBirdClick,
      handleGroupInquiry,
      handleDownloadBrochure
    }
  }
}
</script>

<style scoped>
.pricing-section {
  position: relative;
  overflow: hidden;
}

.section-header {
  margin-bottom: var(--spacing-4xl);
}

.section-title {
  font-size: var(--font-size-4xl);
  font-weight: 700;
  margin-bottom: var(--spacing-lg);
  font-family: var(--font-primary);
}

.section-subtitle {
  font-size: var(--font-size-xl);
  color: var(--idws-text-muted);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.5;
}

.pricing-grid {
  margin-bottom: var(--spacing-3xl);
}

/* Additional Info Section */
.pricing-info-section {
  margin: var(--spacing-4xl) 0;
}

.info-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: var(--shadow-lg);
}

.info-item {
  transition: all 0.3s ease;
}

.info-item:hover {
  transform: translateY(-4px);
}

.info-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--idws-text-dark);
  margin-bottom: var(--spacing-sm);
  font-family: var(--font-primary);
}

.info-text {
  font-size: var(--font-size-base);
  color: var(--idws-text-muted);
  line-height: 1.5;
  margin: 0;
}

/* Early Bird Banner */
.early-bird-banner {
  margin: var(--spacing-3xl) 0;
  opacity: 0;
}

.banner-container {
  background: var(--idws-gradient-accent);
  border-radius: 20px;
  padding: var(--spacing-xl);
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(251, 191, 36, 0.3);
}

.banner-content {
  display: flex;
  align-items: center;
  gap: var(--spacing-xl);
  color: white;
}

.banner-icon {
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text {
  flex-grow: 1;
}

.banner-title {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  margin-bottom: var(--spacing-sm);
  font-family: var(--font-primary);
}

.banner-description {
  font-size: var(--font-size-lg);
  margin: 0;
  opacity: 0.95;
}

.banner-action {
  flex-shrink: 0;
}

/* Group Registration CTA */
.group-registration-cta {
  margin: var(--spacing-3xl) 0;
  opacity: 0;
}

.cta-container {
  border-radius: 24px;
  padding: var(--spacing-3xl);
  box-shadow: var(--shadow-xl);
  position: relative;
  overflow: hidden;
}

.cta-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { transform: translateX(-100%); }
  50% { transform: translateX(100%); }
}

.cta-title {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  margin-bottom: var(--spacing-md);
  font-family: var(--font-primary);
}

.cta-description {
  font-size: var(--font-size-lg);
  margin-bottom: var(--spacing-xl);
  opacity: 0.95;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.cta-actions {
  display: flex;
  gap: var(--spacing-md);
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

/* Responsive Design */
@media (max-width: 768px) {
  .section-title {
    font-size: var(--font-size-2xl);
  }

  .section-subtitle {
    font-size: var(--font-size-base);
  }

  .banner-content {
    flex-direction: column;
    text-align: center;
    gap: var(--spacing-lg);
  }

  .banner-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto;
  }

  .cta-container {
    padding: var(--spacing-2xl);
  }

  .cta-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .cta-actions .btn {
    margin: var(--spacing-xs) 0;
  }

  .info-container {
    margin: 0 var(--spacing-md);
    padding: var(--spacing-lg);
  }
}

@media (max-width: 576px) {
  .banner-container {
    padding: var(--spacing-lg);
    margin: 0 var(--spacing-md);
  }

  .banner-title {
    font-size: var(--font-size-xl);
  }

  .banner-description {
    font-size: var(--font-size-base);
  }

  .cta-title {
    font-size: var(--font-size-xl);
  }

  .cta-description {
    font-size: var(--font-size-base);
  }
}
</style>